import React from "react";
import Axios from "axios";
import axios from "services/axios";
import { Button, Card, message, Spin, Tooltip, Tag } from "antd";
import MUIDataTable from "mui-datatables";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import _ from "lodash";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getPricingAreaList } from "store/actions/area";

import ModalPricingAreaDetail from "./ModalPricingAreaDetail";
import { errorMessage } from "../../../Utils";

let cancelToken;

class PricingAreaList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      areaDetail: {},
      areas: [],
      isLoading: true,
      confirmLoading: false,
      disableButton: true,
      page: 1,
      limit: 15,
      count: 0,
      search: "",
      sort: { name: "date", direction: "desc" },
    };
    this.visibleModalDetail = this.visibleModalDetail.bind(this);
  }

  componentDidMount() {
    this.setState({ isLoading: true });
    this.fetchPricingArea(this.state.page, this.state.limit);
    this.props.getPricingAreaList();
  }

  orderBy(sort) {
    let key = "name";
    let value = "DESC";

    //Get Value
    if (sort.direction === "asc") value = "ASC";
    else if (sort.direction === "desc") value = "DESC";

    return `${key}=${value}`;
  }

  async fetchPricingArea(page, limit) {
    const order = this.orderBy(this.state.sort);
    const query = `${order}&&page=${page}&&limit=${limit}&&search=${
      this.state.search || ""
    }`;
    if (cancelToken) {
      cancelToken.cancel("Operation canceled due to new request");
    }
    cancelToken = Axios.CancelToken.source();

    await axios
      .get(`admin-panel/pricing-area?${query}`, {
        cancelToken: cancelToken.token,
      })
      .then(result => {
        this.setState({
          areas: result.data.areas,
          page: result.data.page,
          limit: result.data.limit,
          count: result.data.count,
          isLoading: false,
        });
      })
      .catch(err => {
        if (!Axios.isCancel(err)) {
          errorMessage(err.response || err);
          this.setState({ isLoading: false });
        }
      });
  }

  changePage(page, limit) {
    this.setState({ isLoading: true });
    this.fetchPricingArea(page, limit);
  }

  visibleModalDetail(area) {
    this.setState({
      visibleModalDetail: !this.state.visibleModalDetail,
      areaDetail: area,
    });
  }

  getMuiTheme = () =>
    createMuiTheme({
      typography: {
        useNextVariants: true,
      },
      overrides: {
        MUIDataTableBodyCell: {
          root: {
            "white-space": "nowrap",

            "&:nth-child(1)": {
              width: "8em",
              "min-width": "8em",
              "max-width": "10em",
              "word-break": "break-all",
            },
            "&:nth-child(2)": {
              width: "10em",
              "min-width": "10em",
              "max-width": "12em",
            },
            "&:nth-child(3)": {
              width: "10em",
              "min-width": "10em",
              "max-width": "12em",
            },
          },
        },
      },
    });

  render() {
    //Columns
    const columns = [
      {
        name: "Action",
        options: {
          sort: false,
        },
      },
      {
        name: "Area Name",
        options: {
          sort: false,
        },
      },
      {
        name: "Plat Nomor",
        options: {
          sort: false,
        },
      },
      {
        name: "Disable Approval",
        options: {
          sort: false,
        },
      },
    ];

    //Data areas
    const areas = this.state.areas.map((item, idx) => {
      return [
        <div>
          <Tooltip placement="bottom" title="Detail Area">
            <Button
              icon="bars"
              style={{ marginRight: 10 }}
              onClick={() => this.visibleModalDetail(item)}
            />
          </Tooltip>
          <Tooltip placement="bottom" title="Update Area">
            <Button
              type="primary"
              icon="edit"
              onClick={() =>
                this.props.history.push({
                  pathname: `/home/pricing-area/${item.id}/update`,
                })
              }
            />
          </Tooltip>
        </div>,
        item.name,
        item.kodePlat,
        item.isDisabled ? (
          <Tag color="green">ON</Tag>
        ) : (
          <Tag color="red">OFF</Tag>
        ),
      ];
    });

    //Options
    const options = {
      filter: false,
      responsive: "simple",
      fixedHeader: true,
      tableBodyHeight: "460px",
      print: false,
      selectableRows: "none",
      // resizableColumns: true,
      download: false,
      viewColumns: false,
      serverSide: true,
      rowsPerPage: this.state.limit,
      count: this.state.count,
      page: this.state.page - 1,
      searchText: this.state.search,
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.changePage(tableState.page + 1, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.changePage(1, tableState.rowsPerPage);
            break;
          case "search":
            this.setState({ search: tableState.searchText }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          case "sort":
            this.setState({ sort: tableState.sortOrder }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          default:
            break;
        }
      },
    };

    return (
      <Card
        title="Pricing Area List"
        style={{
          marginTop: 35,
          background: "#fff",
          minHeight: 360,
        }}>
        <Spin size="large" spinning={this.state.isLoading} tip="Loading...">
          <Link
            to={{
              pathname: `/home/pricing-area/create`,
            }}>
            <Button style={{ marginRight: 8 }}>Create Pricing Area</Button>
          </Link>
          <MuiThemeProvider theme={this.getMuiTheme()}>
            <MUIDataTable
              title="Pricing Area List"
              data={areas}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>

          <ModalPricingAreaDetail
            data={this.state.areaDetail}
            visible={this.state.visibleModalDetail}
            visibleModal={this.visibleModalDetail}
          />
        </Spin>
      </Card>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getPricingAreaList }, dispatch);

export default connect(null, mapDispatchToProps)(PricingAreaList);



// WEBPACK FOOTER //
// src/components/Dashboard/Area/PricingArea/PricingAreaList.js